function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "4fjk51ie4a",
  d: "M5.391 17.6v-3.675h4.87v.173c0 .29.279.527.567.527h2.344c.288 0 .567-.237.567-.527v-.173h4.867l-.001 3.675H5.39zm5.913-4.025h1.392v-.35h-1.392v.35zM18.608 9.2l-.001 3.675h-4.868v-.254c0-.29-.279-.446-.567-.446h-2.344c-.288 0-.567.156-.567.446v.254H5.39V9.2h13.217zM9.74 7.8h4.522V6.4H9.739v1.4zm10.057.165c-.13-.132-.307-.165-.492-.165h-3.652V5.7c0-.387-.345-.7-.73-.7H9.078c-.384 0-.73.313-.73.7v2.1H4.697C4.31 7.8 4 8.033 4 8.42v9.88c0 .387.311.7.696.7H19.3c.384 0 .695-.313.695-.7L20 8.44c0-.186-.073-.344-.204-.475z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "var(--light-grey)",
  xlinkHref: "#4fjk51ie4a"
})));

function SvgIconClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47,
    height: 47,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClient);
export default __webpack_public_path__ + "static/media/icon-client.29c6b74c.svg";
export { ForwardRef as ReactComponent };